import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface InitiateTransferProps {
  offlineFlow: boolean
}

const InitiateTransfer: React.FC<InitiateTransferProps> = ({ offlineFlow }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/dashboard');
    };
    const title = offlineFlow ? "Offline DTS Agreement Created" : "New Agreement Created";
    const subtitle = offlineFlow
      ? "Your offline DTS agreement has been created. You may now download your DTS agreement for offline signatures."
      : "The agreement has been sent to the supplier for signature. Once all signatures are complete and the agreement is finalized, your transfer will be initiated, and the supplier(s) will be able to upload their data for the transfer.";

    return (
        <div style={{ backgroundColor: 'white', height: '100%', minHeight: '440px' }}>
        <Result
            status="success"
            title={title}
            subTitle={subtitle}
            extra={[
                <Button key="buy" onClick={handleClick}>Dashboard</Button>,
            ]}
        />
        </div>
    );
};

export default InitiateTransfer;
